/** Request com os dados para aprovar uma revisão das Análises de Mercado */
export class ClienteAnaliseMercadoRevisaoAprovarRequest {
    ano: number;
    idRepresentante: number;
    justificativa: string;

    constructor(ano: number, idRepresentante: number, justificativa: string) {
        this.ano = ano;
        this.idRepresentante = idRepresentante;
        this.justificativa = justificativa;
    }
}
